"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var ShowIfTranslationExists = function (_a) {
    var translationKey = _a.translationKey, children = _a.children;
    var intl = react_intl_1.useIntl();
    var translated = intl.formatMessage({ id: translationKey });
    if (translated.trim() === '' || translated === translationKey) {
        return null;
    }
    return children;
};
exports.default = ShowIfTranslationExists;
